import { BGMOption } from '../../UI/Popup/BGMDropdown';
import { GameSettingConfig, GameSettingName, GameSettingRegistry } from '../../../../tableEngine/Script/Game/Data/Model/SettingModel';

export const customGameSettingRegistry: Readonly<GameSettingRegistry> = {
    // audio
    [GameSettingName.MusicMute]: true,
    [GameSettingName.EffectMute]: true,
    [GameSettingName.MusicVolume]: true,
    [GameSettingName.EffectVolume]: true,
    [GameSettingName.BGM]: true,

    // language
    [GameSettingName.PreferredLanguage]: true,

    // tutorial
    [GameSettingName.OuterLobbyTutorialShow]: true,
    [GameSettingName.OuterLobbyTutorialComplete]: true,
    [GameSettingName.LobbyTutorialShow]: true,
    [GameSettingName.LobbyTutorialComplete]: true,
    [GameSettingName.CrowdPlayTutorialShow]: true,
    [GameSettingName.CrowdPlayTutorialComplete]: true,
    [GameSettingName.MultiplePlayTutorialShow]: true,
    [GameSettingName.MultiplePlayTutorialComplete]: true,
    [GameSettingName.RoundPlayTutorialShow]: true,
    [GameSettingName.RoundPlayTutorialComplete]: true,
    [GameSettingName.SinglePlayTutorialShow]: true,
    [GameSettingName.SinglePlayTutorialComplete]: true,
};

export const customGameSettingConfig: Readonly<GameSettingConfig> = {
    // audio
    [GameSettingName.MusicMute]: false,
    [GameSettingName.EffectMute]: false,
    [GameSettingName.MusicVolume]: 1,
    [GameSettingName.EffectVolume]: 1,
    [GameSettingName.BGM]: BGMOption.First,

    // language
    [GameSettingName.PreferredLanguage]: undefined,

    // tutorial
    [GameSettingName.OuterLobbyTutorialShow]: false,
    [GameSettingName.OuterLobbyTutorialComplete]: false,
    [GameSettingName.LobbyTutorialShow]: false,
    [GameSettingName.LobbyTutorialComplete]: false,
    [GameSettingName.CrowdPlayTutorialShow]: false,
    [GameSettingName.CrowdPlayTutorialComplete]: false,
    [GameSettingName.MultiplePlayTutorialShow]: false,
    [GameSettingName.MultiplePlayTutorialComplete]: false,
    [GameSettingName.RoundPlayTutorialShow]: false,
    [GameSettingName.RoundPlayTutorialComplete]: false,
    [GameSettingName.SinglePlayTutorialShow]: false,
    [GameSettingName.SinglePlayTutorialComplete]: false,
};
